import type { ProductTaxonomyRenameDefinition } from '../types';

export const messageActivityRename = {
  copy: {
    // Sentence-case "Deliveries & drafts" is the canonical current label for the nav + command
    // palette (cmd-K); production casing is normalized to it flag-off.
    'nav.review.outbox': {
      current: 'Deliveries & drafts',
      future: 'Message activity',
    },
    // The "Deliveries" tab becomes "Sent".
    'nav.review.outbox.deliveries': {
      current: 'Deliveries',
      future: 'Sent',
    },
    // The "Drafts" tab keeps its name; the entry exists so both tabs read from the catalog.
    'nav.review.outbox.drafts': {
      current: 'Drafts',
      future: 'Drafts',
    },
    // "the Delivery Log" → "the Sent log" in the deliveries/sent empty-state description.
    'messageActivity.deliveryLogName': {
      current: 'Delivery Log',
      future: 'Sent log',
    },
    // Noun in the "Learn more about …" docs link under the deliveries/sent empty state.
    'messageActivity.deliveriesLearnMoreNoun': {
      current: 'Deliveries',
      future: 'sent messages',
    },
  },
  routes: {
    // Parent segment `outbox` → `message_activity`; the Deliveries tab segment → `sent`; the Drafts
    // tab segment is unchanged.
    'messageActivity.index': {
      current: '/workspaces/:workspaceId/journeys/outbox',
      future: '/workspaces/:workspaceId/journeys/message_activity',
    },
    'messageActivity.sent': {
      current: '/workspaces/:workspaceId/journeys/outbox/deliveries',
      future: '/workspaces/:workspaceId/journeys/message_activity/sent',
    },
    'messageActivity.drafts': {
      current: '/workspaces/:workspaceId/journeys/outbox/drafts',
      future: '/workspaces/:workspaceId/journeys/message_activity/drafts',
    },
  },
  sideNavItemIds: {
    outbox: 'message-activity',
  },
} as const satisfies ProductTaxonomyRenameDefinition;
